export default __webpack_public_path__ + "static/media/Button1.2df41352.mp3";